import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Defaults } from 'app/lib/constants';
import { Icon, IconSize } from 'app/components/core/Icon';
import { MappedSnowflakeStatusPropType } from 'app/lib/proptypes';
import * as styles from './StatusIndicator.css';

const cx = classnames.bind(styles);

export function StatusIndicator({ className, mappedSnowflakeStatus = Defaults.OBJECT }) {
    const { isError, isSignInRequired, isUnconfigured, isConnected, isConnectedWithWarning } =
        mappedSnowflakeStatus;

    const stateClasses = cx(
        className,
        { 'state-success': isConnected },
        { 'state-error': isError },
        { 'state-warning': isConnectedWithWarning },
        { 'sign-in-required': isSignInRequired },
        { 'state-unconfigured': isUnconfigured }
    );

    return isUnconfigured ? (
        <Icon
            className={cx('statusIcon', stateClasses)}
            variant="info-solid"
            size={IconSize.MINI}
        />
    ) : (
        <span className={cx('status', stateClasses)} aria-live="assertive" />
    );
}

StatusIndicator.propTypes = {
    className: PropTypes.string,
    mappedSnowflakeStatus: MappedSnowflakeStatusPropType
};
